import ChipStatus from "#core/components/ChipStatus"
import AddIcon from "@mui/icons-material/Add"
import { Button } from "@mui/material"
import MUIDataTable from "mui-datatables"
import { Fragment, useState } from "react"
import { JobProfileFormNewDialog } from "../job-profile-form-new/JobProfileFormNew"

export default function JobProfileTable({ data, onClick, reload }) {
	const [open, setOpen] = useState(false)
	const columns = [
		{
			name: "nombre",
			label: "Nombre",
			options: {
				filter: false,
			},
		},
		{
			name: "departamento_name",
			label: "Departamento",
			options: {
				filter: false,
			},
		},
		{
			name: "created_at",
			label: "Creado",
			options: {
				filter: false,
			},
		},

		{
			name: "habilitado",
			label: "Habilitado",
			options: {
				filter: true,
				customBodyRender: (value) => {
					return value === null ? (
						<ChipStatus
							status={true}
							activo="Pendiente De Revisión"
							desactivado=""
							size="medium"
						/>
					) : (
						<ChipStatus
							status={value}
							activo="Habilitado"
							desactivado="No Habilitado"
							size="medium"
						/>
					)
				},
			},
		},
	]
	const onRowClick = (rowData, { dataIndex }) => {
		if (onClick && typeof onClick === "function") onClick(data[dataIndex])
	}
	const options = {
		filter: false,
		download: false,
		print: false,
		viewColumns: false,
		onRowClick,
		selectableRows: "none",
		textLabels: {
			body: {
				noMatch: "No hay Competencias",
			},
		},

		customToolbar: () => (
			<Button color="primary" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
				Agregar Perfil Puesto
			</Button>
		),
	}

	return (
		<Fragment>
			<MUIDataTable title={""} data={data || []} columns={columns} options={options} />
			<JobProfileFormNewDialog open={open} setOpen={setOpen} reload={reload} />
		</Fragment>
	)
}
